<template>
  <div class="action-btn-group d-inline-flex align-items-center">
    <b-button
      v-if="showView"
      size="sm"
      class="button-circle"
      variant="primary"
      @click="$emit('view')"
      :disabled="disabled"
    >
      <i class="fa fa-eye"></i>
    </b-button>

    <b-button
      v-if="showEdit"
      size="sm"
      class="button-circle btn-orange"
      @click="$emit('edit')"
      :disabled="disabled"
    >
      <i class="fa fa-pencil"></i>
    </b-button>

    <b-button
      v-if="showDelete"
      size="sm"
      class="button-circle"
      variant="danger"
      @click="$emit('delete')"
      :disabled="disabled"
    >
      <i class="fa fa-trash"></i>
    </b-button>

    <slot />
  </div>
</template>

<script>
export default {
  name: "ActionButtonGroup",
  props: {
    showView: {
      type: Boolean,
      default: false,
    },
    showEdit: {
      type: Boolean,
      default: false,
    },
    showDelete: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.action-btn-group {
  gap: 4px !important;
}

.action-btn-group >>> .button-circle {
  width: 28px !important;
  height: 28px !important;
  min-width: 28px !important;
  min-height: 28px !important;
  padding: 0 !important;
  font-size: 12px !important;
  line-height: 1 !important;
  box-shadow: none !important;
}

.action-btn-group >>> .button-circle i {
  font-size: 12px !important;
  line-height: 1 !important;
}

.action-btn-group >>> .btn-orange {
  color: #ffffff !important;
  background-color: #fe7b08 !important;
  border-color: #fe7b08 !important;
}

.action-btn-group >>> .btn-orange:hover,
.action-btn-group >>> .btn-orange:focus {
  background-color: #e26c04 !important;
  border-color: #e26c04 !important;
}

.action-btn-group >>> .btn-orange i {
  color: #ffffff !important;
}
</style>
